<script setup>

import SectionHeading from "@/components/settings/ui/SectionHeading.vue";
import DefaultSection from "@/components/settings/ui/DefaultSection.vue";
import SectionSubText from "@/components/settings/ui/SectionSubText.vue";
import DefaultButton from "@/components/global-themed/buttons/DefaultButton.vue";
import CustomToggle from "@/components/global-themed/CustomToggle.vue";
import PackageCard from "@/components/settings/billing/partials/PackageCard.vue";
import {useBillingPackages} from '@/composables/useBillingPackages';
import LoadingBlock from "@/components/global-themed/LoadingBlock.vue";
import {computed} from "vue";

defineProps({
  portalUrl: {
    required: false,
    type: [String, null],
    default: null,
  },
});

const { isYearly, data: packages, isLoading } = useBillingPackages();

const currentPackage = computed(() => {
  return packages.value.find(product => product.current);
});

const getVariant = (item) => {
  if (item.deliverables.number_of_websites < currentPackage.value?.deliverables.number_of_websites) {
    return 'primary-inverted';
  }
  return 'primary';
}
</script>

<template>
  <div class="tw-flex tw-flex-col tw-gap-10">
    <div class="tw-flex tw-flex-col tw-gap-2">
      <SectionHeading>
        Company Settings
      </SectionHeading>

      <DefaultSection>
        <div class="tw-flex tw-flex-col tw-gap-12">
          <div class="tw-flex tw-flex-col tw-gap-4 tw-items-center">
            <span class="tw-flex tw-gap-3 tw-text-neutral-900 tw-items-center">
              Billed Monthly
              <CustomToggle v-model="isYearly" />
              Billed Yearly
            </span>
            <span class="tw-bg-primary tw-text-white tw-rounded-lg tw-py-3 tw-px-4">
              Save 40% with all yearly subscriptions
            </span>
          </div>

          <LoadingBlock v-if="isLoading" />
          <div
            v-else
            class="tw-flex tw-justify-center"
          >
            <div class="tw-flex tw-gap-6 tw-overflow-x-scroll tw-items-end visible-scrollbar">
              <PackageCard
                v-for="item in packages"
                :key="item.id"
                :product="item"
                :variant="getVariant(item)"
              />
            </div>
          </div>
        </div>
      </DefaultSection>
    </div>

    <div
      v-if="portalUrl"
      class="tw-flex tw-flex-col tw-gap-2"
    >
      <SectionHeading>
        Payment and invoices
      </SectionHeading>

      <DefaultSection>
        <div class="tw-flex tw-items-center tw-justify-between">
          <SectionSubText>Manage your billing method</SectionSubText>

          <DefaultButton
            as="a"
            :href="portalUrl"
            target="_blank"
            class="!tw-py-2 !tw-px-6"
          >
            Change Payment Method
          </DefaultButton>
        </div>

        <div class="tw-flex tw-items-center tw-justify-between">
          <SectionSubText>View previous invoices</SectionSubText>

          <DefaultButton
            as="a"
            :href="portalUrl"
            target="_blank"
            class="!tw-py-2 !tw-px-6"
          >
            View Invoices
          </DefaultButton>
        </div>
      </DefaultSection>
    </div>

    <div class="tw-flex tw-flex-col tw-gap-2">
      <SectionHeading>
        Cancel your plan
      </SectionHeading>
      <DefaultSection>
        <div class="tw-flex tw-items-center tw-justify-between">
          <SectionSubText>If you wish to cancel your account please click the cancel subscription button</SectionSubText>

          <DefaultButton
            variant="danger"
            as="a"
            href="/settings/package/cancel"
          >
            Cancel Subscription
          </DefaultButton>
        </div>
      </DefaultSection>
    </div>
  </div>
</template>
